import { createAmazonApiInstance, createFleetApiInstanceWithToken} from '../util';

const general = {
    uploadFile: ({ url, file, contentType }) => {
        return createAmazonApiInstance(url, {
            'Content-Type': contentType ?? file.type,
        }).put('', file);
    },
    importFileByPOST: ({url, file}) => {
        return createFleetApiInstanceWithToken().post(url, file);
    },
};

export default general;
